import {
  ContractorOrderByColumnEnum,
  type ContractorsWhereColumn,
  type GetContractorsQuery,
  type GetContractorsQueryVariables,
  SortOrder,
} from "@src/__generated__/graphql";
import {
  commonQueryVariables,
  commonSearchParams,
  type TRefetch,
} from "@src/utils/apolloHelpers";
import { OrderBy } from "@src/utils/components/sorting/OrderBy";
import { PaginationState } from "@src/utils/mobx/states/PaginationState";
import { computed, makeObservable, observable } from "mobx";
import { ContractorModel } from "./models";

/**
 * store holding projects page related data
 */
export class StoreContractors {
  refetch?: TRefetch<GetContractorsQueryVariables, GetContractorsQuery>;
  orderBy = new OrderBy<ContractorOrderByColumnEnum>([
    { column: ContractorOrderByColumnEnum.Id, order: SortOrder.Asc },
  ]);
  pagination = new PaginationState("contractors");

  @observable searchTerm = "";

  @observable.ref contractors: ContractorModel[] = [];

  @observable.ref allContractorIds: ContractorModel["id"][] = [];

  /**
   * used in bulk actions
   */
  @observable.ref selectedContractorIds: ContractorModel["id"][] = [];

  constructor() {
    makeObservable(this);
  }

  fromGetContractorsQuery(data: GetContractorsQuery) {
    this.contractors = ContractorModel.fromGetContractorsQuery(
      data.contractors,
    );
    if (data.contractors) {
      this.pagination.setFromPaginatorInfo(data.contractors.paginatorInfo);
    }
    this.allContractorIds = data.contractorsSummary.contractorIds;
  }

  @computed get searchParams() {
    return commonSearchParams(this);
  }

  @computed get queryVariables(): GetContractorsQueryVariables {
    const vars = commonQueryVariables<
      ContractorOrderByColumnEnum,
      ContractorsWhereColumn
    >(this);
    return vars;
  }

  static create() {
    return new StoreContractors();
  }
}
